
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   WORKFLOW_ACTION,
   ADD_ACADEMYADMIN,
   ASSIGN_ACADEMYADMIN,
   ASSIGN_COACH_STUDENT,
   ALL_ASSIGNED_STUDENT,
   ASSIGN_PROGRAM_INCLUSION,
   DELETE_ASSIGN_COACH,
   DELETE_COACH_STUDENT,
   GET_PARTICULAR_ACADEMY_PROGRAM,
   ASSIGN_PROGRAM_FOR_STUDENT,
} from 'Actions/types';



export const addAcademyAdmin = (wrkstate, academy, dob, role) => async (dispatch) => {
   if (role == 4) {
      var password = wrkstate.target.password.value;
   } else {
      var password = wrkstate.target.mobile.value;
   }
   var payload = {
      "fname": wrkstate.target.fname.value,
      "lname": wrkstate.target.lname.value,
      "email": wrkstate.target.email.value,
      "phone": wrkstate.target.mobile.value,
      "password": password,
      "dob": dob,
      "roleid": role,
      "gender": wrkstate.target.gender.value,
      "academyid": academy,
      "stype": "",
      "joindate": "",
      "coach": "",
      "selfrm": 1,

   }
   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/addmember', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;
            if (resdata.status === 1) {
               if (role == 2) {
                  NotificationManager.success('Add academy admin successfully');
               } else if (role == 5) {
                  NotificationManager.success('Add golf coach successfully');
               } else if (role == 36) {
                  NotificationManager.success('Add SS coach successfully');
               } else if (role == 37) {
                  NotificationManager.success('Add psychologist successfully');
               } else if (role == 38) {
                  NotificationManager.success('Add nutritionist successfully');
               }
               dispatch({ type: ADD_ACADEMYADMIN });
               return Promise.resolve(resdata);
            } else {
               NotificationManager.error(resdata.message);
            }
         } else {
            NotificationManager.error('Academy Admin not added');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}

export const addAcademyStudent = (wrkstate, academy, dob, coach) => async (dispatch) => {

   var payload = {
      "fname": wrkstate.target.fname.value,
      "lname": wrkstate.target.lname.value,
      "email": wrkstate.target.email.value,
      "phone": wrkstate.target.mobile.value,
      "password": wrkstate.target.password.value,
      "dob": dob,
      "roleid": 4,
      "gender": wrkstate.target.gender.value,
      "academyid": academy,
      "stype": "",
      "joindate": "",
      "coach": coach,
      "selfrm": 2
   }

   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/addmember', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;
            if (resdata.status === 1) {

               NotificationManager.success('Student added successfully');

               dispatch({ type: ADD_ACADEMYADMIN });
               return Promise.resolve(resdata);
            } else {
               NotificationManager.error(resdata.message);
            }
         } else {
            NotificationManager.error('Student not added');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}

export const assignAcademyAdmin = (academy, userid, sendfrom) => async (dispatch) => {

   var payload = {
      "academy": academy,
      "userid": userid
   }
   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/addacademyadmin', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;
            if (resdata.status === 1) {
               if (sendfrom == 1) {
                  NotificationManager.success('Assign academy admin successfully.');
               } else if (sendfrom == 2) {
                  NotificationManager.success('Assign golf coach successfully.');
               } else if (sendfrom == 3) {
                  NotificationManager.success('Assign ss coach successfully.');
               } else if (sendfrom == 4) {
                  NotificationManager.success('Assign psychologist successfully.');
               } else if (sendfrom == 5) {
                  NotificationManager.success('Assign nutritionist successfully.');
               } else if (sendfrom == 6) {
                  NotificationManager.success('Assign Student successfully.');
               }
               dispatch({ type: ASSIGN_ACADEMYADMIN });
               return Promise.resolve(resdata);
            } else {
               NotificationManager.error(resdata.message);
            }
         } else {
            NotificationManager.error('Academy Admin not assign');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}

export const assignAcademyCoach = (academy, userid, sendfrom) => async (dispatch) => {

   var payload = {
      "academy": academy,
      "userid": userid
   }
   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/addacademycoach', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;
            if (resdata.status === 1) {
               if (sendfrom == 1) {
                  NotificationManager.success('Assign academy admin successfully.');
               } else if (sendfrom == 2) {
                  NotificationManager.success('Assign golf coach successfully.');
               } else if (sendfrom == 3) {
                  NotificationManager.success('Assign ss coach successfully.');
               } else if (sendfrom == 4) {
                  NotificationManager.success('Assign psychologist successfully.');
               } else if (sendfrom == 5) {
                  NotificationManager.success('Assign nutritionist successfully.');
               }
               dispatch({ type: ASSIGN_ACADEMYADMIN });
               return Promise.resolve(resdata);
            } else {
               NotificationManager.error(resdata.message);
            }
         } else {
            NotificationManager.error('Academy coach not assign');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}

export const assignStudentCoach = (academy, coach, studentslist) => async (dispatch) => {

   var payload = {
      "academy": academy,
      "assignto": coach,
      "students": studentslist
   }
   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/assignstudent', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               dispatch({ type: ASSIGN_COACH_STUDENT });
               return Promise.resolve(resdata);
            } else {
               NotificationManager.error(resdata.message);
            }
         } else {
            NotificationManager.error('Students not added');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}


export const deleteAcademyCoach = (coach, academy, frmval) => async (dispatch) => {

   var payload = {
      "academy": academy,
      "userid": coach,
   }
   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/deleteacademycoach', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;
            if (resdata.status === 1) {
               if (frmval == 1) {
                  NotificationManager.success('Delete golf coach successfully');
               } else if (frmval == 2) {
                  NotificationManager.success('Delete ss coach successfully.');
               } else if (frmval == 3) {
                  NotificationManager.success('Delete psychologist successfully.');
               } else if (frmval == 4) {
                  NotificationManager.success('Delete nutritionist successfully.');
               }
               dispatch({ type: DELETE_ASSIGN_COACH });
               return Promise.resolve(resdata);
            }
         } else {
            NotificationManager.error('Coach not deleted');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}

export const deleteCoachStudent = (studentid, academy, coach) => async (dispatch) => {

   var payload = {
      "academy": academy,
      "coach": coach,
      "userid": studentid,
   }
   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/deletecoachstudent', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;

            if (resdata.status == 1) {
               NotificationManager.success(resdata.message);
               dispatch({ type: DELETE_COACH_STUDENT });
               return Promise.resolve(resdata);
            }
         } else {
            NotificationManager.error('Student not deleted');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}


export const assignedStudentList = (id, academy) => async (dispatch) => {

   var payload = {
      "assignto": id,
      "academy": academy
   }
   dispatch({ type: WORKFLOW_ACTION });
   axios.post(AppConfig.apiurl + '/api/getassignedstudent', payload, { headers: AuthHeader.header })
      .then(response => {
         const allmembers = response.data.data;
         dispatch({ type: ALL_ASSIGNED_STUDENT, payload: allmembers });
      });

}


export const assignProgramInclusion = (student, programlist) => async (dispatch) => {

   var payload = {
      "student": student,
      "program": programlist
   }
   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/assignstudentprogram', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               dispatch({ type: ASSIGN_PROGRAM_INCLUSION });
               return Promise.resolve(resdata);
            } else {
               NotificationManager.error(resdata.message);
            }
         } else {
            NotificationManager.error('Program not added');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}

export const assignAllStudentCoach = (academy, coach) => async (dispatch) => {

   var payload = {
      "academy": academy,
      "assignto": coach
   }
   dispatch({ type: WORKFLOW_ACTION });
   return axios.post(AppConfig.apiurl + '/api/assignallstudent', payload, { headers: AuthHeader.header })
      .then(response => {
         if (response.status == 200) {
            var resdata = response.data;
            if (resdata.status === 1) {
               NotificationManager.success(resdata.message);
               dispatch({ type: ASSIGN_COACH_STUDENT });
               return Promise.resolve(resdata);
            } else {
               NotificationManager.error(resdata.message);
            }
         } else {
            NotificationManager.error('Students not added');
         }

      })
      .catch(error => {
         NotificationManager.error(error);
      });
}


export const getParticularAcademyProgram = (academy) => async (dispatch) => {
   const payload = {
      "academy": academy
   };
   dispatch({ type: WORKFLOW_ACTION });

   try {
      const response = await axios.post(AppConfig.apiurl + '/api/getparticularacademyprogram', payload, { headers: AuthHeader.header });
      if (response.status === 200) {
         const programs = response.data.data;
         dispatch({ type: GET_PARTICULAR_ACADEMY_PROGRAM, payload: programs });
      } else {
         NotificationManager.error('Failed to fetch academy programs');
      }
   } catch (error) {
      NotificationManager.error(error);
   }
};

export const assignProgramForStudent = (userId, programId) => async (dispatch) => {
   const payload = {
      "userid": userId,
      "program": programId
   };
   dispatch({ type: WORKFLOW_ACTION });

   try {
      const response = await axios.post(AppConfig.apiurl + '/api/assignprogramforstudent', payload, { headers: AuthHeader.header });
      if (response.status === 200) {
         const resdata = response.data;
         if (resdata.status === 1) {
            NotificationManager.success(resdata.message);
            dispatch({ type: ASSIGN_PROGRAM_FOR_STUDENT });
            return Promise.resolve(resdata);
         } else {
            NotificationManager.error(resdata.message);
         }
      } else {
         NotificationManager.error('Program not assigned');
      }
   } catch (error) {
      NotificationManager.error(error);
   }
};




